<template>
    <ul v-if="routes.length" class="nav-links" :class="{'sub-links': subMenu}">
        <template v-for="(route, index) in routes">
            <li v-if="showRouteTree(route)" :key="route.path">
                <router-link v-if="defaultRoute(route)" :to="{ name: defaultRoute(route) }" :class="{ 'sticky': !subMenu }">
                    <span><component v-if="hasIcon(route)" :is="route.meta.icon" size="16"></component></span>
                    {{ getRouteMetaTitle(route) || getRouteName(route.children[0]) }}
                </router-link>
                <router-link v-else :to="{ name: route.name }" :exact="route.meta.exact || false" :class="{ 'sticky': !subMenu }">
                    <span><component v-if="hasIcon(route)" :is="route.meta.icon" size="16" class="w-6"></component></span>
                    {{ getRouteName(route) }}
                </router-link>

                <!-- Sub nav -->
                <nav-links
                    v-if="hasChildren(route)"
                    :routes="filterRouteGroups(route.children)"
                    :group="group"
                    :sub-menu="true"
                ></nav-links>
            </li>
        </template>
    </ul>
</template>

<script>

    // External
    import { mapGetters } from 'vuex';

    // Internal Dependencies
    import { snakeToTitle } from 'helpers/strings.js';
    import AppInfoMixin from '@/mixins/AppInfoMixin.js';
    import SubMenu from './SubMenu.vue';
    import * as Icons from 'Icons';

    export default {
        name: 'NavLinks',

        mixins: [
            AppInfoMixin,
        ],

        props: {
            routes: {
                required: true
            },

            group: {
                type: String,
                default: 'main'
            },

            subMenu: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            ...mapGetters(['user_type']),

            ...mapGetters('config', [
                'configs'
            ]),
        },

        methods: {
            filterRouteGroups(r) {
                return r.filter((route) => {
                    if ( !route.meta ) {
                        return false;
                    }

                    if ( Array.isArray(route.meta.perms) ) {
                        if ( !this.$userCan.apply(this, route.meta.perms) ) {
                            return false;
                        }
                    }

                    if ( Array.isArray(route.meta.user_types) && route.meta.user_types.indexOf(this.user_type) === -1 ) {
                        return false;
                    }

                    if ( route.meta.app && !route.meta.app.includes(this.app_type) ) {
                        return false;
                    }

                    return route.meta.group ? route.meta.group == this.group : false;
                });
            },
            hasChildren(route) {
                if ( typeof route.children == 'undefined' ) {
                    return false;
                }

                return true;
            },
            getRouteMetaTitle(route) {
                if ( route.meta && route.meta.title ) {
                    return snakeToTitle(route.meta.title);
                }

                return null;
            },
            getRouteName(route) {
                let meta_title = this.getRouteMetaTitle(route);

                return snakeToTitle(meta_title || route.name);
            },
            defaultRoute(route) {
                if ( !this.hasChildren(route) ) {
                    return false;
                }

                if ( route.children[0].path == '' ) {
                    return route.children[0].name;
                }

                return false;
            },
            showRouteTree(route) {
                if ( route.meta.config ) {
                    if ( !this.configs[route.meta.config] ) {
                        return false;
                    }
                }

                return true;
            },
            hasIcon(route) {
                if ( typeof route.meta !== 'undefined' ) {
                    return typeof route.meta.icon !== 'undefined';
                }

                return false;
            }
        },

        components: {
            SubMenu,
            ...Icons
        },
    }
</script>
